import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        loader: false,
        telegramContact: null,
        appType: null,
    }),
    actions: {
        toggleLoader(){
            this.loader = !this.loader
        }
    }
})